import {
  ALLOCATED_INSTRUMENT_FILTER_OPTIONS,
  type AllocatedInstrumentFilter,
} from '../lib/allocated-instruments-display'
import { EDITOR_VIEWER_DASHBOARD_LAYOUT } from '../lib/editor-viewer-dashboard-layout'
import { DashboardStatusFilter } from './DashboardStatusFilter'

interface Props {
  value: AllocatedInstrumentFilter
  onChange: (value: AllocatedInstrumentFilter) => void
}

/** Figma `5106:10346` — Filter by Status dropdown (225×42). */
export function AllocatedInstrumentsStatusFilter({ value, onChange }: Readonly<Props>) {
  return (
    <DashboardStatusFilter
      value={value}
      onChange={onChange}
      options={ALLOCATED_INSTRUMENT_FILTER_OPTIONS}
      filterWidth={EDITOR_VIEWER_DASHBOARD_LAYOUT.filterWidth}
      testId="ev-dashboard-instruments-status-filter"
      wrapperTestId="sensemaker-ftux-ev-status-filter"
    />
  )
}
